import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import { BootstrapVue } from "bootstrap-vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHeart,
  faSpade,
  faDiamond,
  faClub,
  faCaretDown,
  faCaretUp,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faHeart as faHeartLight,
  faSpade as faSpadeLight,
  faDiamond as faDiamondLight,
  faClub as faClubLight,
} from "@fortawesome/pro-light-svg-icons";

library.add(
  faHeart,
  faSpade,
  faDiamond,
  faClub,
  faCaretDown,
  faCaretUp,
  faHeartLight,
  faSpadeLight,
  faDiamondLight,
  faClubLight
);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.component("fa", FontAwesomeIcon);

new Vue({
  store,
  render: h => h(App),
}).$mount("#app");
